import { prop } from 'ramda'
import { shallowEqual, useSelector } from 'react-redux'


export function useCompensationEnabledByStudent(studentID: string) {
  const compensaions: {
    compensation_by_statement: boolean,
    compensation_by_cabinet: boolean,
  } = useSelector((state: any) => state.user.students_compensation, shallowEqual)
  const {
    compensation_by_statement: compensationByStatement,
    compensation_by_cabinet: compensationByCabinet,
  } = prop(studentID, compensaions) || { compensation_by_statement: false, compensation_by_cabinet: false }

  return {
    compensationByStatement,
    compensationByCabinet,
  }
}
